export * from "-!../../../../../node_modules/vue-loader/lib/loaders/templateLoader.js??vue-loader-options!../../../../../node_modules/vue-loader/lib/index.js??vue-loader-options!./card.vue?vue&type=template&id=4779efe4&"


//////////////////
// WEBPACK FOOTER
// ./src/templates/components/ui-components/card/card.vue?vue&type=template&id=4779efe4&
// module id = 1000
// module chunks = 0